import { Component, OnInit, HostListener } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, pipe, Subscription, timer } from 'rxjs';
import { startWith, switchMap, skipWhile, takeUntil, map, timeout } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { ClipBoardService } from '../services/clipboard.service'
import { ServerService } from '../services/server.service'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
import { UserProfileModalComponent } from '../pages/users/user-profile-modal/user-profile-modal.component';
import { ResourceModalComponent } from './resource-modal/resource-modal.component';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent implements OnInit {

  userInfo: any = JSON.parse(localStorage.getItem("userInfo"))
  authToken: any = localStorage.getItem("token")

  sidebarFix: boolean = true
  sidebarPin: boolean = false
  notifications: any[] = []
  isExpanded = true;
  badge: any = ""
  showSubmenu: boolean = false;
  showSubmenu1: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  public dummyElem = document.createElement('DIV');
  menus = [];

  vendorDashboard = {
    'name': 'Dashboard',
    'icon': '/assets/images/sidenav-icon/ic_menu_home.png',
    'link': '/page/dashboard-vendor',
  }

  vendors = {
    'name': 'Vendors',
    'icon': '/assets/images/sidenav-icon/ic_menu_vender.png',
    'link': '/page/vendors',
  }

  clients = {
    'name': 'Clients',
    'icon': '/assets/images/sidenav-icon/ic_menu_partners.png',
    'link': '/page/clients',
  }

  campaign = {
    'name': 'Campaign',
    'icon': '/assets/images/sidenav-icon/ic_subscription.png',
    'link': '/page/campaign',
  }

  vendorLeads = {
    'name': 'Master Leads',
    'icon': '/assets/images/sidenav-icon/ic_menu_home.png',
    'link': '/page/leads',
  }

  vendorRules = {
    'name': 'Rules',
    'icon': '/assets/images/sidenav-icon/ic_menu_home.png',
    'link': '/page/assignment-rules',
  }

  vendorAuditLogs = {
    'name': 'Audit Logs',
    'icon': '/assets/images/sidenav-icon/ic_menu_audit_logs.png',
    'link': '/page/logs',
  }

  vendorCallReport = {
    'name': 'Call Reports',
    'icon': '/assets/images/sidenav-icon/ic_log-3.png',
    'link': '/page/call-report',
  }

  vendorLeadReport = {
    'name': 'Lead Reports',
    'icon': '/assets/images/sidenav-icon/ic_menu_lead-details.png',
    'link': '/page/lead-report',
  }

  clientDashboard = {
    'name': 'Dashboard',
    'icon': '/assets/images/sidenav-icon/ic_menu_home.png',
    'link': '/page/dashboard',
  }
  users = {
    'name': 'Users',
    'icon': '/assets/images/sidenav-icon/ic_menu_client.png',
    'link': '/page/users',
  }
  registration = {
    'name': 'Registration',
    'icon': '/assets/images/sidenav-icon/ic_menu_lead-generator.png',
    'link': '/page/registration',
  }

  project = {
    'name': 'Projects',
    'icon': '/assets/images/sidenav-icon/ic_menu_projects.png',
    'link': '/page/project',
    // 'link':'/client-project/project'
  }

  whatsappRule = {
    'name': 'Whatsapp Rules',
    'icon': '/assets/images/sidenav-icon/ic_menu_projects.png',
    'link': '/page/whatsapp-rules',
  }

  lead = {
    'name': 'Master Leads',
    'icon': '/assets/images/sidenav-icon/ic_menu_leads.png',
    'link': '/page/leads',
  }
  rules = {
    'name': 'Rules',
    'icon': '/assets/images/sidenav-icon/ic_rule.png',
    'link': '/page/rules',
  }
  logs = {
    'name': 'Logs',
    'icon': '/assets/images/sidenav-icon/ic_logs.png',
    'link': '/page/logs',
  }
  clientNotification = {
    'name': 'Notifications',
    'icon': '/assets/images/sidenav-icon/ic_notification.png',
    'link': '/page/notification',
  }

  persona = {
    'name': 'Persona',
    'icon': '/assets/images/sidenav-icon/ic_menu_lead-generator.png',
    'link': '/page/persona',
  }

  bookings = {
    'name': 'Bookings',
    'icon': '/assets/images/sidenav-icon/ic_menu_booking.png',
    'link': '/page/bookings',
  }
  salesAccount = {
    'name': 'Sales Account',
    'icon': '/assets/images/sidenav-icon/ic_notification.png',
    'link': '/page/sales-account',
  }
  callLogs = {
    'name': 'Call Logs',
    'icon': '/assets/images/sidenav-icon/phone_forward.png',
    'link': '/page/call-logs',
  }
  scheduler = {
    'name': 'Calendar',
    'icon': '/assets/images/calendar_month_scheduler.png',
    'link': '/page/scheduler',
  }

  ivrCallReport = {
    'name': 'Reports',
    'icon': '/assets/images/sidenav-icon/report icon-24x24.png',
    'link': '/page/reports-dashboard',
  }
  task = {
    'name': 'Tasks',
    'icon': '/assets/images/sidenav-icon/report icon-24x24.png',
    'link': '/page/tasks',
  }
  createCampaign = {
    'name': 'Campaigns',
    'icon': '/assets/images/sidenav-icon/ic_campaign.png',
    'link': '/page/campaign-list',
  }
  createEscalation = {
    'name': 'Escalation',
    'icon': '/assets/images/sidenav-icon/escalations.png',
    'link': '/page/escalation-master',
  }
  createCreative = {
    'name': 'Creative',
    'icon': '/assets/images/sidenav-icon/creative-job.png',
    'link': '/page/creative-master',
  }
  createPresale = {
    'name': 'Presale',
    'icon': '/assets/images/sidenav-icon/presales-job.png',
    'link': '/page/presale-master',
  }
  // createCampaign={
  //   'name': 'Campaigns',
  //   'icon': '/assets/images/sidenav-icon/ic_campaign.png',
  //   'link': '/page/campaign-list',
  // }

  permission = {
    'name': 'Permission',
    'icon': '/assets/images/sidenav-icon/presales-job.png',
    'link': '/page/permission',
  }

  policy = {
    'name': 'Customize Policy',
    'icon': '/assets/images/sidenav-icon/presales-job.png',
    'link': '/page/policy',
  }

  color = {
    'name': 'Color',
    'icon': '/assets/images/sidenav-icon/presales-job.png',
    'link': '/page/color',
  }

  nearbyProjects = {
    'name': 'Nearby Projects',
    'icon': '/assets/images/sidenav-icon/presales-job.png',
    'link': '/near-by',
  }

  CPLCalculator = {
    'name': 'CPL Calculator',
    'icon': '/assets/images/sidenav-icon/presales-job.png',
    'link': '/cpl-calculator',
  }

  marketingReports = {
    'name': 'Marketing Reports',
    'icon': '/assets/images/sidenav-icon/presales-job.png',
    'link': '/cpl-calculator',
  }

  analyticsDashboard = {
    'name': 'Analytics Dashboard',
    'icon': '/assets/images/sidenav-icon/presales-job.png',
    'link': '/cpl-calculator',
  }
  mediaPlan = {
    'name': 'Media Plan',
    'icon': '/assets/images/sidenav-icon/presales-job.png',
    'link': '/cpl-calculator',
  }
  commentMaster = {
    'name': 'Media Plan',
    'icon': '/assets/images/sidenav-icon/presales-job.png',
    'link': '/comment-masters',
  }
  userProfileModalComponent: MatDialogRef<UserProfileModalComponent>
  resourceModelComponent: MatDialogRef<ResourceModalComponent>

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  clientLead: any;
  // localStorage.getItem('userInfo');

  isReportsSubMenuShow: boolean = false;
  isMastersSubMenuShow: boolean = false;
  isRulesSubMenuShow: boolean = false;
  isConfigSubMenuShow: boolean = false;
  isResourcesSubMenuShow: boolean = false;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private serverService: ServerService,
    public clipBoardService: ClipBoardService,
  ) {
    this.clipBoardService.select(window.location.pathname)
    this.clipBoardService.isActive(window.location.pathname)

    if (this.authToken != null) {
      this.serverService.userInfo(this.authToken).subscribe(data => {
        localStorage.removeItem("userInfo")
        localStorage.setItem("userInfo", JSON.stringify(data))
      }, err => {
        this.clipBoardService.checkServerError(err, this.authToken)
      }
      )
    } else {
      this.clipBoardService.backToLogin()
      return
    }

    if (this.userInfo.admin) {
      this.menus = []
      this.menus.push(this.vendorDashboard)
      this.menus.push(this.createCampaign)
      this.menus.push(this.lead)
      this.menus.push(this.users)
      this.menus.push(this.project)
      this.menus.push(this.salesAccount)

      //Reports Dropdown
      this.menus.push(this.vendorAuditLogs)
      this.menus.push(this.callLogs);
      this.menus.push(this.vendorLeadReport)
      this.menus.push(this.ivrCallReport);

      //Masters Dropdown
      this.menus.push(this.vendors)
      this.menus.push(this.clients)
      this.menus.push(this.createPresale)
      this.menus.push(this.createCreative)
      this.menus.push(this.createEscalation)

      //Rule Dropdown  
      this.menus.push(this.whatsappRule)

      //System Config Dropdown  
      this.menus.push(this.permission)
      this.menus.push(this.policy)
      this.menus.push(this.color)

      //Resources Dropdown
      this.menus.push(this.nearbyProjects)
      this.menus.push(this.CPLCalculator)
      this.menus.push(this.marketingReports)
      this.menus.push(this.analyticsDashboard)
      



      this.menus.push(this.bookings)
      this.menus.push(this.mediaPlan)
      
      //this.menus.push(this.campaign)

    } else {
      if (this.userInfo.member_type == "Vendor") {
        this.menus = []
        if (this.userInfo.org_admin) {
          this.menus.push(this.vendorDashboard)
          this.menus.push(this.users)
          this.menus.push(this.project)
          this.menus.push(this.clients)
          this.menus.push(this.lead)
          this.menus.push(this.rules)
          this.menus.push(this.vendorAuditLogs)
          this.menus.push(this.vendorCallReport)
          // removed leadreport form V admin only available at SuperAdmin IZ 09-10-23
          const isExportPresent: boolean = this.userInfo["permissions"].some(item => item.name === "export");
          if (isExportPresent) {
            this.menus.push(this.vendorLeadReport)
          }

          //
          // this.menus.push(this.persona)
          // this.menus.push(this.bookings)
          this.menus.push(this.whatsappRule)
          this.menus.push(this.ivrCallReport);
          this.menus.push(this.createCampaign)
          this.menus.push(this.mediaPlan)
          // this.menus.push(this.createEscalation)
          // this.menus.push(this.createCreative)
          // this.menus.push(this.createPresale)
        }
        //role == null

        // if (this.userInfo.role == null) {
        //   this.menus = []
        // //   if (this.userInfo.org_admin) {
        //     this.menus.push(this.vendorDashboard)

        // }

        else if (this.userInfo.role == "SalesAdmin") {
          this.menus.push(this.vendorDashboard)
          this.menus.push(this.project)
          this.menus.push(this.createCampaign)
          this.menus.push(this.mediaPlan)
          //this.menus.push(this.createEscalation)
          //this.menus.push(this.createCreative)
          //this.menus.push(this.createPresale)
        }
        else if (this.userInfo.role == "FinanceAdmin") {
          this.menus.push(this.vendorDashboard)
          this.menus.push(this.project)
          this.menus.push(this.createCampaign)
          //this.menus.push(this.createEscalation)
          //this.menus.push(this.createCreative)
          //this.menus.push(this.createPresale)
        }
        else if (this.userInfo.role == "CreativeAdmin") {
          this.menus.push(this.vendorDashboard)
          this.menus.push(this.project)
          this.menus.push(this.createCampaign)
          //this.menus.push(this.createEscalation)
          //this.menus.push(this.createCreative)
          //this.menus.push(this.createPresale)
        }
        else if (this.userInfo.role == "BudgetManager") {
          // this.menus.push(this.vendorDashboard)
          this.menus.push(this.project)
          this.menus.push(this.createCampaign)
          //this.menus.push(this.createEscalation)
          //this.menus.push(this.createCreative)
          //this.menus.push(this.createPresale)
        }

        // changes made.....
        else {
          this.menus.push(this.project)
          // // this.menus.push(this.clients)
          this.menus.push(this.lead)
          this.menus.push(this.vendorAuditLogs)
          // this.menus.push(this.scheduler)
          // this.menus.push(this.vendorDashboard);          
        }

      } else {
        this.menus = []
        if (this.userInfo.org_admin) {
          this.menus.push(this.clientDashboard)
          this.menus.push(this.users)
          this.menus.push(this.project)
          // this.menus.push(this.vendors)
          this.menus.push(this.rules)
          // this.menus.push(this.registration)
          this.menus.push(this.task)
          this.menus.push(this.mediaPlan)
        } else {
          this.menus.push(this.project)
          this.menus.push(this.task)
          this.menus.push(this.mediaPlan)
          // this.menus.push(this.scheduler)
          // this.menus.push(this.vendors)
          // this.menus.push(this.registration)
        }
        // this.menus.push(this.bookings)
      }
    }
  }

  ngOnInit() {
    // console.log(this.userInfo["permissions"])

    // setTimeout(() => {
    //   alert('Hi')
    //   //this.getLeadCount()
    // }, 1000);


    this.getLeadCount()

  }

  hasClass: boolean = true
  removeMenuClass() {
    this.hasClass = false;
  }

  addMenuClass() {
    if (!this.sidebarFix) {
      this.hasClass = false;
    } else {
      this.hasClass = true;
    }

  }


  toggleMenu(submenuType: any) {

    if (submenuType == 'reports') {
      this.isReportsSubMenuShow = !this.isReportsSubMenuShow;
      //this.isReportsSubMenuShow = false;
      this.isMastersSubMenuShow = false;
      this.isRulesSubMenuShow = false;
      this.isConfigSubMenuShow = false;
      this.isResourcesSubMenuShow = false;
    }

    if (submenuType == 'masters') {
      this.isMastersSubMenuShow = !this.isMastersSubMenuShow;
      this.isReportsSubMenuShow = false;
      //this.isMastersSubMenuShow = false;
      this.isRulesSubMenuShow = false;
      this.isConfigSubMenuShow = false;
      this.isResourcesSubMenuShow = false;
    }

    if (submenuType == 'rules') {
      this.isRulesSubMenuShow = !this.isRulesSubMenuShow;
      this.isReportsSubMenuShow = false;
      this.isMastersSubMenuShow = false;
      //this.isRulesSubMenuShow = false;
      this.isConfigSubMenuShow = false;
      this.isResourcesSubMenuShow = false;
    }

    if (submenuType == 'config') {
      this.isConfigSubMenuShow = !this.isConfigSubMenuShow;
      this.isReportsSubMenuShow = false;
      this.isMastersSubMenuShow = false;
      this.isRulesSubMenuShow = false;
      //this.isConfigSubMenuShow = false;
      this.isResourcesSubMenuShow = false;
    }

    if (submenuType == 'resources') {
      this.isResourcesSubMenuShow = !this.isResourcesSubMenuShow;
      this.isReportsSubMenuShow = false;
      this.isMastersSubMenuShow = false;
      this.isRulesSubMenuShow = false;
      this.isConfigSubMenuShow = false;
      //this.isResourcesSubMenuShow = false;
    }

  }

  logout() {
    //localStorage.clear()
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('caller-id-number')
    localStorage.removeItem('projectInfo')
    localStorage.removeItem('deleteAttachment')
    localStorage.removeItem('Attachment_job')
    localStorage.removeItem('link_deletion_job')
    localStorage.removeItem('link_deletion')
    localStorage.removeItem('leadInfo')
    localStorage.removeItem('report')
    localStorage.removeItem('pivotData')
    localStorage.removeItem('permissions')
    sessionStorage.clear()
    this.clipBoardService.showMessgeInText("Logged Out Successfully", "success-snackbar")
    this.router.navigate([""])
  }

  pinActive() {
    this.sidebarPin = true;
    this.sidebarFix = false;
    this.hasClass = false;
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    })
  }

  pinDeactive() {
    this.sidebarPin = false;
    this.sidebarFix = true;
    this.hasClass = true;
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    })
  }

  showProfile() {
    this.userProfileModalComponent = this.dialog.open(UserProfileModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '500px',
      panelClass: 'cdk-overlay-panel-right-side'
    });
  }

  refresh() {
    this.router.navigateByUrl('/page/***', { skipLocationChange: true }).then(() =>
      this.router.navigate([location.pathname]));
  }


  subscription: any;
  getLeadCount() {

    this.subscription = timer(0, 300000).pipe(switchMap(() => this.serverService.getFreshLeadCount('get_lead_count', this.authToken))
    ).subscribe(data => {
      this.clientLead = data;
      //alert('Hi')
    }
    );

  }
  showResource() {
    const dialogRef = this.dialog.open(ResourceModalComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: '600px',
      height: '190px',
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');

    });
  }


  showCallerID() {
    this.router.navigate(['/call-setting-page/call-setting-dashboard']);
  }

  stakeholderDashboard() {
    window.open('/stakeholder/dashboard',"_blank")
    // this.router.navigate(['/call-setting-page/call-setting-dashboard']);
  }


  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

}
